/**
 * User UI Constants
 */

/**
 * Assignment sayfası (/my-assignment) için tab tanımları - kartlardaki kart durumları
 */
export const ASSIGNMENT_TABS_ITEMS = [
  { 
    key: 'just_assigned', 
    value: true, 
    label: 'education.new_assigned_education', 
    countKey: 'just_assigned',
    filterKey: 'just_assigned'
  },
  { 
    key: 'on_progress', 
    value: true, 
    label: 'education.ongoing_education', 
    countKey: 'on_progress',
    filterKey: 'on_progress'
  },
  { 
    key: 'completed', 
    value: true, 
    label: 'education.completed_education', 
    countKey: 'completed',
    filterKey: 'completed'
  },
  { 
    key: 'repeat_it', 
    value: true, 
    label: 'education.repeat_education', 
    countKey: 'repeat_it',
    filterKey: 'repeat_it'
  },
  { 
    key: 'all', 
    value: false, 
    label: 'education.all_education', 
    countKey: 'all',
    filterKey: 'with_expired',
    isAll: true
  }
]


